module.exports = __webpack_public_path__ + "img/hr-green-pita-11.79d9f868.png";